import { get } from "lodash"

export const alertTransformer = (contentItem) => ({
  text: get(contentItem, "elements.text.value"),
  linkTo: linkToTransformer(
    get(contentItem, "elements.link_to.value[0]")
  ),
})

export const linkToTransformer = (contentItem) =>
  get(contentItem, "resolved_url") ||
  get(contentItem, "elements.url.value")
